/* eslint-disable camelcase */
import { useUIDSeed } from "react-uid";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { Button, buttonSizes, buttonVariants } from "../../../../Button";
import { withErrorBoundary } from "../../../../ErrorBoundary";
import { ArrowSmallIcon, Icon } from "../../../../Icon";
import { Image } from "../../../../Image";
import styles from "./Trophy.style";

const TrophyStyled = styled.div((props) => ({ ...styles(props) }));

// Trophy Helper function
const TrophyItem = ({ image, title }) => (
    <li className="trophyItem">
        <div className="trophyItem_image">
            <Image image={image} alt={title} />
        </div>
        <span className="trophyItem_title">{title}</span>
    </li>
);

const Trophy = ({ title, linkTitle, linkUrl, className, trophies, ...rest }) => {
    const uid = useUIDSeed();

    if (!trophies?.length) {
        return null;
    }

    return (
        <TrophyStyled className={className} {...rest}>
            <div className="trophyCard">
                {!!title && (
                    <div className="trophyCard_head">
                        <span className="trophyCard_title">{title}</span>
                    </div>
                )}
                <ul className="trophyCard_list">
                    {trophies.slice(0, 3).map((trophy, index) => {
                        const { assets: { badge_normal: baseNormalName } = {} } = trophy;
                        const trophyUrl = `/trophies/badges/${baseNormalName}`;

                        return (
                            <TrophyItem
                                key={uid(trophy?.id || index)}
                                title={trophy.name}
                                image={trophyUrl}
                            />
                        );
                    })}
                </ul>
                {!!linkUrl && (
                    <div className="trophyCard_footer">
                        <Button
                            variant={buttonVariants.TERTIARY}
                            size={buttonSizes.SMALL}
                            title={linkTitle}
                            href={linkUrl}
                            iconRightComponent={<Icon icon={ArrowSmallIcon} size={20} />}
                        >
                            {linkTitle}
                        </Button>
                    </div>
                )}
            </div>
        </TrophyStyled>
    );
};

TrophyItem.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
};

TrophyItem.defaultProps = {
    image: undefined,
    title: undefined,
};

Trophy.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    linkTitle: PropTypes.string,
    linkUrl: PropTypes.string,
    trophies: PropTypes.arrayOf(PropTypes.object),
};

Trophy.defaultProps = {
    className: undefined,
    title: undefined,
    linkTitle: undefined,
    linkUrl: undefined,
    trophies: undefined,
};

export default withErrorBoundary(Trophy);
